var year = 2026;

var lang:any=[];
	lang['en']={};
	lang['en']["munmak_title"]="Munmak";
	lang['en']["lethal_blade_title"]="Lethal Blade";
	lang['en']["thief_title"]="Fast Cat Flash Rat";
    lang['en']["low"]="Low";
	lang['en']["high"]="High";
	lang['en']["profile"]="Profile";
	lang['en']["welcome"]="Welcome";
	lang['en']["bandwidth"]="Bandwidth";
	lang['en']["new_games"]="New Hot Games";
	lang['en']["please_enter_your_name"]="Enter your name";
	lang['en']["please_sign_in"]="Please sign in";
	lang['en']["signup"]="Sign Up";
	lang['en']["email"]="Email";
	lang['en']["password"]="Password";
	lang['en']["username"]="Username";
	lang['en']["repassword"]="Repassword";
	lang['en']["login"]="Login";
	lang['en']["singlemode"]="Single Player";
	lang['en']["multimode"]="Start Multiplayer";
	lang['en']["onlinemode"]="Online";
	lang['en']["wrong_password"]="Wrong password";
	lang['en']["verification_success"]="Verification Successful";
	lang['en']["ok_title"]="OK";
	lang['en']["cancel_title"]="Cancel";
	lang['en']["back"]="Back";
	lang['en']["play"]="Play";
	lang['en']["logout"]="Logout";
	lang['en']["welcome_back"]="Welcome Back";
	lang['en']["forget_password"]="Forget Password";
	lang['en']["change_password"]="Change Password";
	lang['en']["play_free"]="Play Free";
	lang['en']["copyright_title"]="Copyright © "+year;
	lang['en']["all_right_reserve_title"]="All Rights Reserved.";

	lang['en']["signup_success"]="Signup Successful! Please check your email to verify your account.";
	lang['en']["reset_password_success"]="Password reset successful! Please check your email for the new password.";
	lang['en']["network_error"]="Network Error";
	lang['en']["not_verified"]="Account not verified. Please check your email for the verification link.";
	lang['en']["missing_password"]="Missing password";
	lang['en']["missing_repassword"]="Missing repassword";
	lang['en']["missing_username"]="Missing username";
	lang['en']["missing_email"]="Missing email";
	lang['en']["email_not_found"]="Email not found";
	lang['en']["password_not_match"]="Password and repassword do not match";
	lang['en']["password_must_be_at_least_6_characters"]="Password must be at least 6 characters";
	lang['en']["duplicate_email"]="Duplicate email";
	lang['en']["duplicate_user"]="Duplicate user";
	lang['en']["missing_friend_name"]="Missing friend name";
	lang['en']["invite_friends_count"]="Invite how many friends";
	lang['en']["friend_name"]="Friend Name";


lang['th']={};
	lang['th']["munmak_title"]="มันส์มาก";
	lang['th']["lethal_blade_title"]="ศึกใบพัดเหล็ก";
	lang['th']["thief_title"]="แมวเฟี้ยว หนูฟ้าว";
    lang['th']["low"]="ต่ำ";
	lang['th']["high"]="สูง";
	lang['th']["bandwidth"]="แบนด์วิดท์";
	lang['th']["profile"]="โปรไฟล์";
	lang['th']["welcome"]="ยินดีต้อนรับ";
	lang['th']["new_games"]="เกมใหม่";
	lang['th']["please_enter_your_name"]="กรอกชื่อเล่น";
	lang['th']["please_sign_in"]="กรุณาเข้าสู่ระบบ";
	lang['th']["signup"]="สมัครสมาชิก";
	lang['th']["email"]="อีเมล";
	lang['th']["password"]="รหัสผ่าน";
	lang['th']["username"]="ชื่อผู้ใช้";
	lang['th']["repassword"]="ยืนยันรหัสผ่าน";
	lang['th']["login"]="เข้าสู่ระบบ";
	lang['th']["singlemode"]="ผู้เล่นคนเดียว";
	lang['th']["multimode"]="ชวนเพื่อนมาเล่น";
	lang['th']["onlinemode"]="เล่นออนไลน์";
	lang['th']["wrong_password"]="รหัสผ่านไม่ถูกต้อง";
	lang['th']["verification_success"]="การยืนยันสำเร็จ";
	lang['th']["ok_title"]="ตกลง";
	lang['th']["cancel_title"]="ยกเลิก";
	lang['th']["back"]="กลับ";
	lang['th']["play"]="เล่น";
	lang['th']["logout"]="ออกจากระบบ";
	lang['th']["welcome_back"]="ยินดีต้อนรับ!";
	lang['th']["forget_password"]="ลืมรหัสผ่าน";
	lang['th']["change_password"]="เปลี่ยนรหัสผ่าน";
	lang['th']["play_free"]="เล่นฟรี";
	lang['th']["copyright_title"]="ลิขสิทธิ์ © "+(year+543);
	lang['th']["all_right_reserve_title"]="มันส์มากสงวนสิทธิ์";

	lang['th']["signup_success"]="สมัครสมาชิกสำเร็จ! กรุณาตรวจสอบอีเมลของคุณเพื่อยืนยันบัญชีของคุณ";
	lang['th']["reset_password_success"]="รีเซ็ตรหัสผ่านสำเร็จ! กรุณาตรวจสอบอีเมลของคุณสำหรับรหัสผ่านใหม่";
	lang['th']["network_error"]="ข้อผิดพลาดของเครือข่าย";
	lang['th']["not_verified"]="บัญชีไม่ได้รับการยืนยัน กรุณาตรวจสอบอีเมลของคุณสำหรับลิงก์ยืนยัน";
	lang['th']["missing_password"]="ไม่มีรหัสผ่าน";
	lang['th']["missing_repassword"]="ไม่มีการยืนยันรหัสผ่าน";
	lang['th']["missing_username"]="ไม่มีชื่อผู้ใช้";
	lang['th']["missing_email"]="ไม่มีอีเมล";
	lang['th']["email_not_found"]="ไม่พบอีเมล";
	lang['th']["password_not_match"]="รหัสผ่านและการยืนยันรหัสผ่านไม่ตรงกัน";
	lang['th']["password_must_be_at_least_6_characters"]="รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร";
	lang['th']["duplicate_email"]="อีเมลซ้ำ";
	lang['th']["duplicate_user"]="ผู้ใช้ซ้ำ";
	lang['th']["missing_friend_name"]="กรุณากรอกชื่อเพื่อน";
	lang['th']["invite_friends_count"]="ชวนเพื่อนกี่คน";
	lang['th']["friend_name"]="ชื่อเพื่อนคนที่";


lang['cn']={};
	lang['cn']["munmak_title"]="Munmak";
	lang['cn']["lethal_blade_title"]="致命之刃";
	lang['cn']["thief_title"]="快猫闪鼠";
    lang['cn']["low"]="低";  
	lang['cn']["high"]="高";
	lang['cn']["profile"]="个人资料";
	lang['cn']["welcome"]="欢迎";
	lang['cn']["bandwidth"]="带宽";
	lang['cn']["new_games"]="新游戏";
	lang['cn']["please_enter_your_name"]="请输入您的名字";
	lang['cn']["please_sign_in"]="请登录";
	lang['cn']["signup"]="注册";
	lang['cn']["email"]="电子邮件";
	lang['cn']["password"]="密码";
	lang['cn']["username"]="用户名";
	lang['cn']["repassword"]="确认密码";
	lang['cn']["login"]="登录";
	lang['cn']["singlemode"]="单人模式";
	lang['cn']["multimode"]="好友同玩";
	lang['cn']["onlinemode"]="在线模式";
	lang['cn']["wrong_password"]="密码错误";
	lang['cn']["verification_success"]="验证成功";
	lang['cn']["ok_title"]="确定";
	lang['cn']["cancel_title"]="取消";
	lang['cn']["back"]="返回";
	lang['cn']["play"]="玩";
	lang['cn']["welcome_back"]="欢迎回来!";
	lang['cn']["forget_password"]="忘记密码";
	lang['cn']["play_free"]="免费玩";
	lang['cn']["copyright_title"]="版权 © "+year;
	lang['cn']["all_right_reserve_title"]="云雾保留所有权利";
	lang['cn']["missing_friend_name"]="缺少朋友的名字";
	lang['cn']["invite_friends_count"]="邀请多少朋友";
	lang['cn']["friend_name"]="朋友的名字";


lang['jp']={};
	lang['jp']["munmak_title"]="Munmak";
	lang['jp']["lethal_blade_title"]="Lethal Blade";
	lang['jp']["thief_title"]="Fast Cat Flash Rat";
    lang['jp']["low"]="低";
	lang['jp']["high"]="高";
	lang['jp']["profile"]="プロフィール";
	lang['jp']["welcome"]="ようこそ";
	lang['jp']["bandwidth"]="带宽";
	lang['jp']["new_games"]="新游戏";
	lang['jp']["please_enter_your_name"]="请输入您的名字";
	lang['jp']["please_sign_in"]="请登录";
	lang['jp']["signup"]="注册";
	lang['jp']["email"]="电子邮件";
	lang['jp']["password"]="密码";
	lang['jp']["login"]="登录";
	lang['jp']["singlemode"]="单人模式";
	lang['jp']["multimode"]="好友同玩";
	lang['jp']["onlinemode"]="在线模式";
	lang['jp']["wrong_password"]="密码错误";
	lang['jp']["verification_success"]="验证成功";
	lang['jp']["ok_title"]="确定";
	lang['jp']["cancel_title"]="取消";
	lang['jp']["back"]="返回";
	lang['jp']["play"]="玩";
	lang['jp']["welcome_back"]="欢迎回来!";
	lang['jp']["forget_password"]="忘记密码";
	lang['jp']["play_free"]="免费玩";
	lang['jp']["copyright_title"]="版权 © "+year;
	lang['jp']["all_right_reserve_title"]="云雾保留所有权利";
	lang['jp']["missing_friend_name"]="友達の名前がありません";
	lang['jp']["invite_friends_count"]="友達を何人招待しますか";
	lang['jp']["friend_name"]="友達の名前";

lang['kr']={};
	lang['kr']["munmak_title"]="Munmak";
	lang['kr']["lethal_blade_title"]="Lethal Blade";
	lang['kr']["thief_title"]="Fast Cat Flash Rat";
	lang['kr']["low"]="낮음";
	lang['kr']["high"]="높음";
	lang['kr']["profile"]="프로필";
	lang['kr']["welcome"]="환영합니다";
	lang['kr']["bandwidth"]="带宽";
	lang['kr']["new_games"]="新游戏";
	lang['kr']["please_enter_your_name"]="请输入您的名字";
	lang['kr']["please_sign_in"]="请登录";
	lang['kr']["signup"]="注册";
	lang['kr']["email"]="电子邮件";
	lang['kr']["password"]="密码";
	lang['kr']["login"]="登录";
	lang['kr']["singlemode"]="单人模式";
	lang['kr']["multimode"]="多人模式";
	lang['kr']["onlinemode"]="在线模式";
	lang['kr']["wrong_password"]="密码错误";
	lang['kr']["verification_success"]="验证成功";
	lang['kr']["ok_title"]="确定";
	lang['kr']["cancel_title"]="取消";
	lang['kr']["back"]="返回";
	lang['kr']["play"]="玩";
	lang['kr']["welcome_back"]="欢迎回来!";
	lang['kr']["forget_password"]="忘记密码";
	lang['kr']["play_free"]="免费玩";
	lang['kr']["copyright_title"]="版权 © "+year;
	lang['kr']["all_right_reserve_title"]="云雾保留所有权利";
	lang['kr']["missing_friend_name"]="친구 이름이 없습니다";
	lang['kr']["invite_friends_count"]="친구를 몇 명 초대하시겠습니까?";
	lang['kr']["friend_name"]="친구 이름";

export class Lang {
	public static get = (l: string, key: string): string => {
		return lang[l][key];
	}
}
